'use strict';
const	ComponentFactory	= require('factories/Component')
		, React				= require('react')
		, Formsy			= require('formsy-react')
		;

module.exports = Formsy.Decorator()(ComponentFactory.create({
	displayName : 'Input',
	construct : function(){
		this.state = {
			blurred : false
		}
	},
	methods : {
		onChange : function(e) {
			this.props.setValue(e.currentTarget.value);

			this.props.onChange &&
			this.props.onChange(e,e.currentTarget.value)
		},
		onBlur : function(){
			if(!this.state.blurred) {
				this.setState({
					blurred : true
				})
			}

			let _value = this.props.getValue();

			if(_value) {
				_value = _value.trim();
			}

			this.props.setValue(_value)

			this.props.onBlur &&
			this.props.onBlur()
		},
		getValue : function(){
			return this.refs.input.value
		}
	},
	render : function(){

		let _additionalProps = {
			onClick : this.props.onClick,
			onFocus : this.props.onFocus,
			onKeyUp : this.props.onKeyUp,
			autoComplete : this.props.autoComplete,
			id : this.props.id,
			className : this.props.className,
			name : this.props.name,
			type : this.props.type || 'text',
			disabled : this.props.disabled,
			defaultValue : this.props.defaultValue,
			value : this.props.value,
			placeholder : this.props.placeholder,
			maxLength : this.props.maxLength,
			max : this.props.max,
			min : this.props.min
		}

		return (
			<div className={!this.props.isPristine() && (this.state.blurred || this.props.isFormSubmitted()) && (this.props.showError() || this.props.showRequired()) ? 'form-error' : ''}>
				<input ref="input" {..._additionalProps} value={this.props.getValue() || ''} onChange={this.onChange.bind(this)} onBlur={this.onBlur.bind(this)} />
				<p className='form-msg'>{this.props.getErrorMessage()}</p>
			</div>
		)
	}
}))



// WEBPACK FOOTER //
// resources/modules/decorators/form/input.jsx